import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIcon, AppText, styled } from '@streem/ui-react';
import theme from '@streem/ui-react/src/styles/theme';
export default function MutedOnCallMessage() {
    return (_jsxs(MuteModalOnCall, { children: [_jsx(MutedIcon, { children: _jsx(AppIcon, { name: "MutedIcon", style: { width: '100%', height: '100%', margin: 'auto 0' } }) }), _jsx(AppText, { color: "white", style: { margin: 'auto 0px auto 16px' }, children: "You are muted, please unmute by clicking the mic icon" })] }));
}
const MuteModalOnCall = styled.div `
    position: fixed;
    top: 62vh;
    width: 90%;
    z-index: 40;
    display: flex;
    padding: 8px 16px;
    border-radius: 11px;
    background-color: rgba(61, 61, 61, 0.3);
    box-shadow: ${props => props.theme.shadow.small};
    color: ${props => props.theme.text.color.white};
    font-size: ${props => props.theme.text.size.medium};
`;
const MutedIcon = styled.span `
    background-color: ${theme.colors.grey05};
    border-radius: 25px;
    padding: 5px;
    width: 40px;
    height: 40px;
    margin: auto 0px;
`;
//# sourceMappingURL=muted_on_call_message.js.map